import React,{useState,useEffect} from 'react'
import { Button, Timeline } from 'flowbite-react';
import axios from 'axios'
import { HiAcademicCap } from 'react-icons/hi';
export default function PortfolioEducation({user_id}) {
    const [loading, setLoading] = useState(true)
    const [data, setData] = useState([
      {
        "edu_id": 1,
        "user_id": "3",
        "name": "HSC",
        "name_bangla": "HSC",
        "grade": 3.67,
        "passing_year": 2017,
        "passing_year_bangla": 2017
    },
    {
      "edu_id": 2,
      "user_id": 3,
      "name": "SSC",
      "name_bangla": "SSC",
      "grade": 2.87,
      "passing_year": 2014,
      "passing_year_bangla": 2014
  }
    ])
    const [lan, setLan] = useState('bangla')
    const baseURL = "https://mukti-backend-bd.onrender.com"
    const getData = async () => {
        try {
            const res = await axios.get(`${baseURL}/edu/${user_id}`)
            console.log(res.data)
            setData(res.data)
            setLoading(false)
        } catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        if (localStorage.getItem('language') === 'english') {
            setLan('english')
        } else {
            setLan('bangla')
        }
        getData()
    }, [])
  return (
    <Timeline horizontal>
     {data.map(a=>(
        <Timeline.Item>
        <Timeline.Point icon={HiAcademicCap} />
        <Timeline.Content>
          <Timeline.Time>
            {lan=="bangla"?a.passing_year:a.passing_year}
          </Timeline.Time>
          <Timeline.Title>
          {lan=="bangla"?a.name:a.name}
          </Timeline.Title>
          <Timeline.Body>
            <p>
                {lan=="bangla"?a.grade:a.grade}
            </p>
          </Timeline.Body>
        </Timeline.Content>
      </Timeline.Item>
     )) }
      </Timeline>
  )
}
